import React, { useState } from 'react';
import { newsletterAPI } from '../utils/api';
import { toast } from 'sonner';
import { Sparkles, ArrowRight } from 'lucide-react';

export const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      await newsletterAPI.subscribe({ email });
      toast.success('Successfully subscribed! Check your inbox for exclusive deals.');
      setEmail('');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to subscribe');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-12 px-4" data-testid="newsletter-section">
      <div className="max-w-3xl mx-auto">
        <div className="relative bg-gradient-to-br from-brand-green via-brand-green to-emerald-800 rounded-2xl p-8 md:p-10 overflow-hidden shadow-xl">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
            }}></div>
          </div>
          
          {/* Decorative circles */}
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-brand-yellow/20 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-brand-red/20 rounded-full blur-3xl"></div>
          
          <div className="relative z-10 text-center">
            {/* Icon */}
            <div className="inline-flex items-center justify-center w-14 h-14 bg-brand-yellow rounded-xl mb-5 shadow-lg">
              <Sparkles className="w-7 h-7 text-brand-green" />
            </div>
            
            {/* Title */}
            <h2 className="text-2xl md:text-3xl font-playfair font-bold text-white mb-2">
              Never Miss a Deal
            </h2>
            <p className="text-gray-200 text-sm md:text-base mb-6 max-w-md mx-auto">
              Get the hottest deals and exclusive coupons delivered straight to your inbox.
            </p>
            
            {/* Form */}
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-testid="newsletter-form">
              <div className="flex-1 relative">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  className="w-full px-5 py-3.5 rounded-xl bg-white/95 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-brand-yellow text-sm font-medium shadow-inner"
                  data-testid="newsletter-email-input"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="inline-flex items-center justify-center gap-2 bg-brand-red hover:bg-red-600 text-white px-6 py-3.5 rounded-xl font-semibold text-sm uppercase tracking-wide disabled:opacity-50 smooth-transition shadow-lg hover:shadow-xl hover:-translate-y-0.5 transform"
                data-testid="newsletter-submit-button"
              >
                {loading ? 'Subscribing...' : (
                  <>
                    Subscribe
                    <ArrowRight className="w-4 h-4" />
                  </>
                )}
              </button>
            </form>
            
            {/* Trust text */}
            <p className="text-gray-300/80 text-xs mt-4">
              No spam, ever. Unsubscribe anytime.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
